import { namespace } from 'vuex-class';
import { ITemplateLibraryState } from '@/document-manipulator/create-page/template-library-old/store/template-library-old.types';

export const TemplateLibrary = namespace('documentManipulator/createPage/templateLibraryOld');

export const state: ITemplateLibraryState = {
  loading: false,
  loaded: false,
  folderId: '',
  templates: [],
  folders: [],
  folderTree: null,
  breadcrumbs: [],
  searchQuery: '',
  pagination: {
    pageMargin: 0,
    pageSize: 6,
    currentPage: 1,
    totalRows: 0,
  },
};

export enum ETemplateLibraryAction {
  LoadTemplates = 'loadTemplates',
  LoadTemplatesSuccess = 'loadTemplatesSuccess',
  LoadTemplatesFailed = 'loadTemplatesFailed',

  LoadFolders = 'loadFolders',
  LoadFoldersSuccess = 'loadFoldersSuccess',
  LoadFoldersFailed = 'loadFoldersFailed',

  LoadBreadcrumbs = 'loadBreadcrumbs',
  LoadBreadcrumbsSuccess = 'loadBreadcrumbsSuccess',

  LoadFolderTree = 'loadFolderTree',
  LoadFolderTreeSuccess = 'loadFolderTreeSuccess',

  SetFolderId = 'setFolderId',
  SetPagination = 'setPagination',
  Search = 'search',
  Reset = 'reset',
}

export enum ETemplateLibraryMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetTemplates = 'setTemplates',
  SetPagination = 'setPagination',
  SetSearchQuery = 'setSearchQuery',
  SetFolders = 'setFolders',
  SetBreadcrumbs = 'setBreadcrumbs',
  SetFolderTree = 'setFolderTree',
  SetFolderId = 'setFolderId',
  SetState = 'setState',
}
